/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_SellerInputs */

const cs_enum_seller = /** @type {(inputs: Enum_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prodávající`)
};

const en_enum_seller = /** @type {(inputs: Enum_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seller`)
};

/**
* | output |
* | --- |
* | "Seller" |
*
* @param {Enum_SellerInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_seller = /** @type {((inputs?: Enum_SellerInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_SellerInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_seller(inputs)
	return cs_enum_seller(inputs)
});